// src/components/ShareModal.js
import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './ShareModal.css';

/**
 * Componente ShareModal (versión mínima)
 * @param {function} onClose - Función para cerrar el modal.
 * @param {string} shareUrl - URL que se va a compartir.
 * @param {string} shareText - Texto adicional para compartir.
 */
const ShareModal = ({ onClose, shareUrl, shareText }) => {

  // Función fallback para copiar texto al portapapeles
  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      alert('Enlace copiado al portapapeles');
    } catch (err) {
      alert('No se pudo copiar el enlace');
    }
    document.body.removeChild(textArea);
  };

  const handleShareWhatsApp = () => {
    const text = encodeURIComponent(`${shareText}\n${shareUrl}`);
    window.open(`https://api.whatsapp.com/send?text=${text}`, '_blank');
  };

  const handleCopyLink = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl)
        .then(() => alert('Enlace copiado al portapapeles'))
        .catch(() => fallbackCopyTextToClipboard(shareUrl));
    } else {
      fallbackCopyTextToClipboard(shareUrl);
    }
  };

  // **Modificación Importante**:
  // Eliminamos la llamada a ReactDOM.createPortal para que ShareModal se comporte como los demás modales.
  // Ahora simplemente retornamos el JSX, y ModalContainer se encargará de montar este modal en "modal-root".
  return (
    <div className="share-modal-overlay" onClick={() => { console.log('Close button clicked'); onClose(); }}>
      <div className="share-modal" onClick={(e) => e.stopPropagation()}>
        <div className="share-modal-header">
          <h5>Compartir</h5>
          <button className="close-button" onClick={() => { console.log('Close button clicked'); onClose(); }}>
            <FaTimes />
          </button>
        </div>
        <div className="share-modal-body">
          <button className="share-button whatsapp-button" onClick={handleShareWhatsApp}>
            Compartir en WhatsApp
          </button>
          <button className="share-button" onClick={handleCopyLink}>
            Copiar Enlace
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
